// extracted by mini-css-extract-plugin
export default {"container":"y15aL","title":"ic8jE","load":"P0b2k","description":"LMX55"};